module.exports = __webpack_public_path__ + "static/media/cp3.5ee48801.png";